export default [
    // 售后管理-》customer
    {
        path: "aftersales/customer/list",
        name: "afterCustomer",
        component: () => import(/* webpackChunkName: "aftersales" */ "@/views/aftersales/customer/index"),
    },
    {
        path: "aftersales/customer/update/:type",
        name: "updateAfterCustomer",
        component: () => import(/* webpackChunkName: "aftersales" */ "@/views/aftersales/customer/update"),
    },
    // 售后管理-》售后单
    {
        path: "aftersales/saleorders/list",
        name: "afterSaleorders",
        component: () => import(/* webpackChunkName: "aftersales" */ "@/views/aftersales/saleorders/index"),
    },
    // 编辑添加页面
    {
        path: "aftersales/saleorders/update/:type",
        name: "afterSaleUpdate",
        component: () => import(/* webpackChunkName: "aftersales" */ "@/views/aftersales/saleorders/update"),
    },

] 